import * as React from "react";
import styled from "styled-components";
import Routes from "routing/Routes";
import { Button, Table as BaseTable } from "components/bootstrap";
import { IfPermitted } from "components/common";
const Table = styled(BaseTable)`
  margin: 16px 0;
`;
const RoundButton = styled(Button)`
  border-radius: 4px;
`;
function AssociatedEventDefs({ eventDefinitions }) {
  return /* @__PURE__ */ React.createElement(Table, { condensed: true }, /* @__PURE__ */ React.createElement("tbody", null, eventDefinitions.map((eventDefinition) => /* @__PURE__ */ React.createElement("tr", { key: eventDefinition.id }, /* @__PURE__ */ React.createElement("td", null, eventDefinition.title), /* @__PURE__ */ React.createElement("td", { style: { textAlign: "right" } }, /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `eventdefinitions:edit:${eventDefinition.id}` }, /* @__PURE__ */ React.createElement(RoundButton, { bsSize: "xs", href: Routes.ALERTS.DEFINITIONS.edit(eventDefinition.id), target: "_blank" }, "View")))))));
}
export default AssociatedEventDefs;
